import React, { useEffect } from "react";

const DISCORD_INVITE = "https://discord.gg/cKWpT7HGam";

const DiscordRedirect = () => {
  useEffect(() => {
    // Update page metadata for Discord redirect (for social sharing)
    document.title = "Join Kusari Discord | Kusari";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Join the Kusari Discord community! Connect with artists, creators, and the global onchain art community.');
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Join Kusari Discord');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Join the Kusari Discord community! Connect with artists, creators, and the global onchain art community.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://kusari.org/discord');
    }
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Join Kusari Discord');
    }
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'Join the Kusari Discord community! Connect with artists, creators, and the global onchain art community.');
    }
    
    const twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) {
      twitterUrl.setAttribute('content', 'https://kusari.org/discord');
    }

    // Instant redirect
    window.location.replace(DISCORD_INVITE);
  }, []);

  return (
    <div style={{ 
      padding: 40, 
      textAlign: "center",
      fontFamily: "system-ui, -apple-system, sans-serif",
      color: "#333"
    }}>
      <h2>Redirecting to Kusari Discord…</h2>
      <p>
        If you are not redirected, <a href={DISCORD_INVITE}>click here</a>.<br/>
        (Or enable JavaScript)
      </p>
    </div>
  );
};

export default DiscordRedirect; 